<app-enfaf-modal
  [title]="'(' + studentsLimit + ') Estudiantes del curso' + (courseName ? ': ' + courseName : '')"
  (onConfirm)="closeModal()"
  [showCancelButton]="false"
  [buttonConfirmText]="'Cerrar'"
  [svgIcon]="'modal-group'"
>
  @if (isLoadingCourse) {
    <div class="loading-page">
      <mat-spinner color="primary"></mat-spinner>
    </div>
  }
  @if (!isLoadingCourse && students.length) {
    <div class="form-control">
      <mat-form-field appearance="outline" color="primary">
        <mat-label>Buscar un estudiante</mat-label>
        @if (isSearchingStudent) {
          <mat-spinner matSuffix></mat-spinner>
        }
        <input
          matInput
          [(ngModel)]="studentToSearch.name"
          name="studentToSearch"
          placeholder="Email, nombre o apellidos"
          autocomplete="off"
          (ngModelChange)="filterStudent()"
        />
      </mat-form-field>
      <div class="filter-progress">
        <div class="filter-col">
          <mat-form-field appearance="outline" color="primary">
            <mat-label>Clases completadas</mat-label>
            <input
              matInput
              type="number"
              [(ngModel)]="studentToSearch.classesCompleted"
              name="classesCompletedToSearch"
              placeholder="Clases completadas"
              autocomplete="off"
              (ngModelChange)="filterStudent()"
            />
          </mat-form-field>
        </div>
        <div class="filter-col">
          <mat-form-field appearance="outline" color="primary">
            <mat-label>Curso finalizado</mat-label>
            <mat-select
              [(ngModel)]="studentToSearch.finished"
              name="finishedToSearch"
              placeholder="Curso finalizado"
              (ngModelChange)="filterStudent()"
            >
              <mat-option [value]="null"> - </mat-option>
              <mat-option [value]="true"> Sí </mat-option>
              <mat-option [value]="false"> No </mat-option>
            </mat-select>
          </mat-form-field>
        </div>
      </div>
      <div class="remove-filters">
        <div class="results">
          <b>{{ filteredStudents.length }} resultados</b>
        </div>
        <div class="actions">
          <button
            mat-flat-button
            color="secondary"
            (click)="clearFilters()"
            [disabled]="!studentToSearch.name && studentToSearch.classesCompleted === null && studentToSearch.finished === null"
          >
            <mat-icon slot="start">filter_alt_off</mat-icon>
            <span>Quitar filtro</span>
          </button>
        </div>
      </div>
    </div>
  }
  @if (!isLoadingCourse && !filteredStudents.length) {
    <div class="no-current">No hay estudiantes disponibles</div>
  }

  @if (students.length) {
    <div
      class="students"
      infiniteScroll
      [infiniteScrollDistance]="1"
      [infiniteScrollThrottle]="50"
      (scrolled)="onScrollDown()"
      [scrollWindow]="false"
      [infiniteScrollDisabled]="infiniteScrollDisabled"
    >
      @if (!isLoadingCourse && filteredStudents.length && screenWidth < 992) {
        <div class="list">
          @for (student of filteredStudents; track student.userId; let i = $index) {
            <div class="item-container">
              <div class="item">
                <div class="item-header">
                  <span>{{ student.name }} {{ student.lastname }}:</span>
                  <span>{{ student.email }}</span>
                  @if (student.phone) {
                    <span>({{ student.phonePrefix || '-' }}) {{ student.phone }}</span>
                  }
                </div>

                @if (courseId === utils.freeBiomechanicsCourseId && student.finished) {
                  <div class="item-details">
                    @if (!student.finished) {
                      <button
                        mat-stroked-button
                        color="secondary"
                        (click)="completeCourse(i, student.userId)"
                        [disabled]="student.isCompletingCourse"
                      >
                        @if (student.isCompletingCourse) {
                          <mat-spinner class="secondary-spinner"></mat-spinner>
                        } @else {
                          <span>Completar curso</span>
                        }
                      </button>
                    }
                    <button
                      mat-flat-button
                      color="secondary"
                      (click)="downloadBiomechanisStudentDiploma(i, student.userId)"
                      [disabled]="student.downloadingDiploma"
                    >
                      @if (student.downloadingDiploma) {
                        <mat-spinner class="white-spinner"></mat-spinner>
                      } @else {
                        <span>Descargar diploma</span>
                      }
                    </button>
                  </div>
                }

                @if (courseId === utils.personalTrainerCourseId) {
                  <div class="item-details">
                    <button
                      mat-flat-button
                      color="secondary"
                      (click)="downloadPersonalTrainerCourseDiploma(i, student.userId)"
                      [disabled]="student.downloadingDiploma"
                    >
                      @if (student.downloadingDiploma) {
                        <mat-spinner class="white-spinner"></mat-spinner>
                      } @else {
                        <span>Descargar diploma</span>
                      }
                    </button>
                  </div>
                }
              </div>
              <div class="progress-details">
                <div class="progress-details-content">
                  <div class="detail"><b>Clases completadas:</b> {{ student.classesCompleted }}</div>
                  <div class="detail">
                    <b>Curso finalizado:</b>
                    @if (student.finished) {
                      <mat-icon class="finished">check_circle</mat-icon>
                    } @else {
                      <mat-icon class="no-finished">cancel</mat-icon>
                    }
                  </div>
                  <div class="detail">
                    <b>Fecha de finalización:</b>
                    {{ student.finishedDate ? (student.finishedDate | date: 'dd MMM yyyy' : '' : 'es' | uppercase) : '-' }}
                  </div>
                </div>
              </div>
            </div>
          }
        </div>
      }

      @if (!isLoadingCourse && filteredStudents.length && screenWidth >= 992) {
        <div class="students-table">
          <table>
            <thead>
              <tr>
                <th class="name">Nombre</th>
                <th class="documents">Documentos</th>
                <th class="classes-completed">Clases completadas</th>
                <th class="finished">Curso finalizado</th>
                <th class="finished-date">Fecha de finalización</th>
                <th class="options">Opciones</th>
              </tr>
            </thead>
            <tbody>
              @for (student of filteredStudents; track student.userId; let i = $index) {
                <tr>
                  <td class="name">
                    <span>{{ student.name }} {{ student.lastname }}</span>
                    <span>{{ student.email }}</span>
                    @if (student.phone) {
                      <span>({{ student.phonePrefix || '-' }}) {{ student.phone }}</span>
                    }
                  </td>
                  <td class="documents">
                    @if (!student.haveDocuments) {
                      <span> - </span>
                    } @else {
                      <button
                        mat-flat-button
                        color="secondary"
                        (click)="downloadStudentCourseDocuments(student)"
                        [disabled]="student.isDownloadingDocuments"
                      >
                        @if (!student.isDownloadingDocuments) {
                          <mat-icon slot="start">download</mat-icon>
                        }
                        @if (!student.isDownloadingDocuments) {
                          <span>Documentos</span>
                        }
                        @if (student.isDownloadingDocuments) {
                          <mat-spinner class="secondary-spinner"></mat-spinner>
                        }
                      </button>
                    }
                  </td>
                  <td class="classes-completed">
                    {{ student.classesCompleted }}
                  </td>
                  <td class="finished">
                    @if (student.finished) {
                      <mat-icon class="finished"> check_circle </mat-icon>
                    } @else {
                      <mat-icon class="no-finished"> cancel </mat-icon>
                    }
                  </td>
                  <td class="finished-date">
                    {{ student.finishedDate ? (student.finishedDate | date: 'dd MMM yyyy' : '' : 'es' | uppercase) : '-' }}
                  </td>
                  @if (courseId !== utils.freeBiomechanicsCourseId && courseId !== utils.personalTrainerCourseId) {
                    <td class="options">
                      @if (!student.finished) {
                        <button
                          mat-stroked-button
                          color="secondary"
                          (click)="completeCourse(i, student.userId)"
                          [disabled]="student.isCompletingCourse"
                        >
                          @if (student.isCompletingCourse) {
                            <mat-spinner class="secondary-spinner"></mat-spinner>
                          } @else {
                            <span>Completar curso</span>
                          }
                        </button>
                      } @else {
                        <button
                          mat-flat-button
                          color="secondary"
                          (click)="downloadCourseStudentDiploma(i, student.userId)"
                          [disabled]="student.downloadingDiploma"
                        >
                          @if (student.downloadingDiploma) {
                            <mat-spinner class="white-spinner"></mat-spinner>
                          } @else {
                            <span>Descargar diploma</span>
                          }
                        </button>
                      }

                      @if (data.generateEnrollmentOrder) {
                        <div class="item-details">
                          <button mat-flat-button color="secondary" (click)="generateEnrollmentOrder(student.userId)">
                            <span>Orden de matrícula</span>
                          </button>
                        </div>
                      }
                    </td>
                  }
                  @if (courseId === utils.freeBiomechanicsCourseId) {
                    <td class="options">
                      @if (!student.finished) {
                        <button
                          mat-stroked-button
                          color="secondary"
                          (click)="completeCourse(i, student.userId)"
                          [disabled]="student.isCompletingCourse"
                        >
                          @if (student.isCompletingCourse) {
                            <mat-spinner class="secondary-spinner"></mat-spinner>
                          } @else {
                            <span>Completar curso</span>
                          }
                        </button>
                      } @else {
                        <button
                          mat-flat-button
                          color="secondary"
                          (click)="downloadBiomechanisStudentDiploma(i, student.userId)"
                          [disabled]="student.downloadingDiploma"
                        >
                          @if (student.downloadingDiploma) {
                            <mat-spinner class="white-spinner"></mat-spinner>
                          } @else {
                            <span>Descargar diploma</span>
                          }
                        </button>
                      }
                    </td>
                  }
                  @if (courseId === utils.personalTrainerCourseId) {
                    <td class="options">
                      <button
                        mat-flat-button
                        color="secondary"
                        (click)="downloadPersonalTrainerCourseDiploma(i, student.userId)"
                        [disabled]="student.downloadingDiploma"
                      >
                        @if (student.downloadingDiploma) {
                          <mat-spinner class="white-spinner"></mat-spinner>
                        } @else {
                          <span>Descargar diploma</span>
                        }
                      </button>
                    </td>
                  }
                </tr>
              }
            </tbody>
          </table>
        </div>
      }

      @if (isLoadingScroll) {
        <div class="loading-scroll">
          <mat-spinner color="primary" class="primary-spinner"></mat-spinner>
        </div>
      }
    </div>
  }
</app-enfaf-modal>
